'use client';

import { Card } from '@/app/(components)/shared/Card/Card';
import { mq } from '@/lib/StyledComponents/mq';
import type { PartnersCardBlockData } from '@/schema/cms/blocks/PartnersCardBlock.schema';
import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';

const StyledCard = styled(Card)`
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;

  ${mq(null, 'laptop')} {
    width: 90%;
  }
`;

export const PartnersCard = ({
  partners,
}: {
  partners: PartnersCardBlockData['logos'];
}) => {
  return (
    <StyledCard>
      {partners.map(partner => {
        return (
          <Link
            href={partner.link}
            key={partner.logo.url}
            rel="noopener noreferrer"
            target="_blank"
          >
            <Image
              src={partner.logo.url}
              alt={partner.logo.alt}
              height={128}
              width={128}
            ></Image>
          </Link>
        );
      })}
    </StyledCard>
  );
};
